import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225 } from "@faire/retailer-settings/FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";

export const useSettingEnableDiscoverCategoryCTABanners =
  (): IThreeVariantXP.Bucket =>
    useSetting(FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225);

export const useAssignSettingEnableDiscoverCategoryCTABanners = () =>
  useAssignSetting(FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225);
